import { t } from 'i18next';

import { signOut } from 'auth/services/auth';
import { IAuthUser } from 'auth/types';
import { AccessPermissions, VersionType } from 'core/enums';
import { VersionTypeHelper } from 'core/helpers';
import { goTo } from 'core/utils';
import { oldOldHomePath, oldReportsPath, oldUserProfilePath } from 'profile/routes/routePaths';
import { systemSettingsPath } from 'system/routes/routePaths';

export const profileMenuStructure = (
  user: IAuthUser | null,
  onUserVersionChange: (user: IAuthUser | null) => void,
  openSwithUsersForm: () => void
) => {
  const userVersionType = VersionTypeHelper.determineVersionTypeByUser(user);
  const changeToVersionType =
    userVersionType === VersionType.ALTERNATE ? VersionType.LEGACY : VersionType.ALTERNATE;
  const isAdmin = user?.admin;

  return [
    {
      name: t('labelMyProfile'),
      onClick: () => goTo(oldUserProfilePath()),
    },
    {
      name: t('labelSystemSettings'),
      url: systemSettingsPath(),
      hide: !isAdmin,
      permissions: [AccessPermissions.SYSTEM_SETTINGS],
    },
    {
      name: t('labelReports'),
      onClick: () => goTo(oldReportsPath()),
    },
    {
      name: t('labelHomeOld'),
      onClick: () => goTo(oldOldHomePath()),
      hide: !isAdmin,
    },
    {
      name: t('labelSwitchUserVersionType', {
        versionType: VersionTypeHelper.getVersionTypeLabel(changeToVersionType),
      }),
      permissions: [AccessPermissions.SWITCH_USER_VERSION],
      onClick: () => onUserVersionChange(user),
    },

    {
      name: t('labelSignOut'),
      onClick: () => signOut(),
    },
    {
      name: t('labelSwitchAccount'),
      onClick: () => openSwithUsersForm(),
      hide: !(isAdmin || user?.impersonated),
    },
  ];
};
